import { create } from 'zustand';

type Balance = {
  star: number;
};

interface BalanceStore {
  balance: Balance;
  setBalance: (balance: Balance) => void;
}

const useBalanceStore = create<BalanceStore>((set) => ({
  balance: {
    star: 0,
  },
  setBalance: (balance: Balance) => set({ balance }),
}));

export default useBalanceStore;
